import React from "react";
import "./ImagenPrevia.css";

const ImagenPrevia = ({
  titulo,
  tituloPregunta,
  imagen,
  onContinuar,
  className = "",
}) => {
  return (
    <div className={`test-container ${className}`}>
      <h1 className="test-title">{titulo}</h1>

      <div className="pregunta-card">
        <p className="instruccion-img">{tituloPregunta}</p>
        {imagen && (
          <div className="imagen-pag">
            <img src={imagen} alt="Imagen del test" />
          </div>
        )}
      </div>

      <button onClick={onContinuar} className="btn-continuar">
        Continuar
      </button>
    </div>
  );
};

export default ImagenPrevia;